import InfoItem2 from './infoitem2'

export default InfoItem2
